import { useI18n } from '../i18n/useI18n'
import type { SurvivorStatus } from '../game/types'

const STATUS_KEYS: Record<
  SurvivorStatus,
  'status_idle' | 'status_onmission' | 'status_injured' | 'status_resting'
> = {
  Idle: 'status_idle',
  OnMission: 'status_onmission',
  Injured: 'status_injured',
  Resting: 'status_resting',
}

const TONES: Record<SurvivorStatus, string> = {
  Idle: 'bg-stone-800 text-stone-300 ring-stone-700',
  OnMission: 'bg-amber-950 text-amber-300 ring-amber-800',
  Injured: 'bg-red-950 text-red-300 ring-red-800',
  Resting: 'bg-emerald-950 text-emerald-300 ring-emerald-800',
}

export function StatusBadge({
  status,
  labelOverride,
  toneOverride,
}: {
  status: SurvivorStatus
  labelOverride?: string
  toneOverride?: string
}) {
  const { t } = useI18n()
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ring-1 ring-inset ${toneOverride ?? TONES[status]}`}
    >
      {labelOverride ?? t(STATUS_KEYS[status])}
    </span>
  )
}
